import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import BaseForm from '../../app/components/BaseForm';

const FormDeleteAutomacao = ({
  isOpen,
  onClose,
  onConfirm,
  automacao,
  itemLabel = 'automação',
  title = 'Excluir Automação',
}) => {
  if (!automacao) return null;

  const handleSubmit = () => {
    onConfirm(automacao);
  };

  const fields = [
    {
      id: 'confirmacao',
      type: 'info',
      content: `Você está prestes a excluir a ${itemLabel} "${automacao.nome || 'sem nome'}".`,
    },
    {
      id: 'aviso',
      type: 'warning',
      content:
        'Esta ação não poderá ser desfeita. Todos os dados associados serão permanentemente removidos.',
    },
  ];

  const renderFields = () => (
    <div className="max-h-[calc(80vh-120px)] overflow-y-auto px-1 space-y-4">
      <div className="mb-4 pb-2">
        <h3 className="text-md font-medium text-gray-700">
          Confirmação de Exclusão
        </h3>
      </div>
      {fields.map((field, index) => (
        <div key={field.id} className="space-y-2">
          {field.type === 'info' && (
            <div className="bg-gray-50 p-4 rounded-md">
              <p className="text-gray-700">{field.content}</p>
            </div>
          )}
          {field.type === 'warning' && (
            <div className="bg-red-50 p-4 rounded-md border border-red-200">
              <div className="flex items-start">
                <FiAlertTriangle className="text-red-500 mt-0.5 mr-2 flex-shrink-0" />
                <p className="text-red-700 text-sm">{field.content}</p>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={title}
      icon={<FiAlertTriangle className="w-6 h-6" />}
      primaryColor="#EF4444"
      isValid={true}
      submitButtonText="Excluir"
      cancelButtonText="Cancelar"
    >
      {renderFields()}
    </BaseForm>
  );
};

export default FormDeleteAutomacao;